import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../components/Spinner';

import Layout from '../components/Layout';

export default function WaitingPermission({ fetching, Page }) {
  return fetching ? (
    <Layout mapImageOnBackground={false}>
      <div
        style={{
          display: 'flex',
          height: '85vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner />
      </div>
    </Layout>
  ) : (
    Page
  );
}

WaitingPermission.propTypes = {
  fetching: PropTypes.bool.isRequired,
  Page: PropTypes.node.isRequired,
};
